export const validateDetailsForm = (formData) => {
    const errors = [];
  
    if (!formData.listingName || formData.listingName.trim() === '') {
      errors.push({
        errorType: 'listingName',
        error: 'Listing Name is required'
      });
    }
  
    if (!formData.transportation || formData.transportation.trim() === '') {
      errors.push({
        errorType: 'transportation',
        error: 'Transportation is required'
      });
    }
  
    if (!formData.parking || formData.parking.trim() === '') {
      errors.push({
        errorType: 'parking',
        error: 'Parking is required'
      });
    }
  
    if (!formData.aboutListing || formData.aboutListing.trim() === '') {
      errors.push({
        errorType: 'aboutListing',
        error: 'Summary is required'
      });
    }
  
    return {isValid: errors.length === 0, errors};
  };